import React, { useEffect, useState } from "react";

const STORAGE_KEY = "cookie_notice_acknowledged";

const COPY = {
  en: {
    label: "Cookie notice",
    text: "This site uses cookies to collect analytics.",
    privacy: "Privacy Policy",
    ok: "OK",
  },
  ru: {
    label: "Уведомление о cookies",
    text: "Этот сайт использует cookies для сбора аналитики.",
    privacy: "Политика конфиденциальности",
    ok: "OK",
  },
  fr: {
    label: "Avis sur les cookies",
    text: "Ce site utilise des cookies pour collecter des statistiques.",
    privacy: "Politique de confidentialité",
    ok: "OK",
  },
  de: {
    label: "Cookie-Hinweis",
    text: "Diese Website verwendet Cookies zur Erfassung von Analysedaten.",
    privacy: "Datenschutzerklärung",
    ok: "OK",
  },
  es: {
    label: "Aviso de cookies",
    text: "Este sitio usa cookies para recopilar analítica.",
    privacy: "Política de privacidad",
    ok: "OK",
  },
  pt: {
    label: "Aviso de cookies",
    text: "Este site usa cookies para coletar análises.",
    privacy: "Política de privacidade",
    ok: "OK",
  },
  it: {
    label: "Avviso sui cookie",
    text: "Questo sito usa cookie per raccogliere dati analitici.",
    privacy: "Informativa privacy",
    ok: "OK",
  },
  tr: {
    label: "Çerez bildirimi",
    text: "Bu site analiz toplamak için çerezler kullanır.",
    privacy: "Gizlilik Politikası",
    ok: "OK",
  },
  ar: {
    label: "إشعار ملفات تعريف الارتباط",
    text: "يستخدم هذا الموقع ملفات تعريف الارتباط لجمع التحليلات.",
    privacy: "سياسة الخصوصية",
    ok: "OK",
  },
};

function getCurrentLocale() {
  if (typeof window === "undefined") return "en";

  const match = window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/i);
  return COPY[match?.[1]] ? match[1] : "en";
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [locale, setLocale] = useState("en");

  useEffect(() => {
    if (typeof window === "undefined") return;

    setLocale(getCurrentLocale());
    setVisible(!window.localStorage.getItem(STORAGE_KEY));
  }, []);

  const acknowledgeNotice = () => {
    window.localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  const copy = COPY[locale] || COPY.en;

  return (
    <div
      className="cookie-banner"
      role="region"
      aria-label={copy.label}
      aria-live="polite"
    >
      <div className="cookie-banner-inner">
        <p className="cookie-text">
          {copy.text}{" "}
          <a className="cookie-link" href="/privacy/">
            {copy.privacy}
          </a>
        </p>
        <div className="cookie-actions">
          <button
            className="cookie-btn cookie-btn-primary"
            type="button"
            onClick={acknowledgeNotice}
          >
            {copy.ok}
          </button>
        </div>
      </div>
    </div>
  );
}
